import { __awaiter, __extends, __generator } from "tslib";
import BaseRepository from '@/core/standard/BaseRepository';
import { axiosInstance } from '@/setup/axios/AxiosConfig';

var ScreenServices =
/** @class */
function (_super) {
  __extends(ScreenServices, _super);

  function ScreenServices() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.collection = 'screens';
    _this.version = 'v1';
    return _this;
  }

  ScreenServices.prototype.getByTpv = function (params) {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , this.request(params)];
      });
    });
  };

  return ScreenServices;
}(BaseRepository);

export default new ScreenServices(axiosInstance);